import clsx, {type ClassValue} from "clsx"
import {twMerge} from "tailwind-merge"

export function cx(...args: ClassValue[]) {
    return twMerge(clsx(...args))
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Tremor focusInput [v0.0.1]

export const focusInput = [
    // base
    "focus:ring-2",
    // ring color
    "focus:ring-grass-400",
    // border color
    "focus:border-grass-400",
]

// Tremor focusRing [v0.0.1]

export const focusRing = [
    // base
    "outline outline-offset-2 outline-0 focus-visible:outline-2",
    // outline color
    "outline-white",
]

// Tremor hasErrorInput [v0.0.1]

export const hasErrorInput = [
    // base
    "ring-2",
    // border color
    "border-rose-500",
    // ring color
    "ring-rose-500",
]